<template>
  <div class="footer">
    {{ /* Btn retour, masqué sur pages de resultats */ }}
    <div v-if="showBtnBack" class="footer_question">
      <div
        class="btn_footer-back"
        @click="backHistory(), clearState(node.answers[0].state)"
      >
        Précédent
      </div>
    </div>

    {{ /* Affichage pendant première page de proposition, avec texte dans le footer */ }}
    <div
      v-if="current_question == 8 || current_question == 9"
      class="footer_recommandation"
    >
      <div class="footer_texte">
        Découvrir une autre sélection ?<br />
        Faisons connaissance en 3 questions...
      </div>

      <div
        @click="
          changeQuestion(node.next);
          RESET_OFFSET();
        "
        class="btn_footer btn_footer-white fs-12"
      >
        Approfondir ma recherche
      </div>
    </div>

    {{ /* Affichage pendant seconde page de proposition "pour moi"*/ }}
    <div
      v-if="current_question == 100 || current_question == 101"
      class="footer_recommandation"
    >
      {{ /* Au click on change l'offset avec selon la réponse donnée à la fréquence de lecture*/ }}
      <div
        @click="relance(offSetFreq, node.next)"
        class="btn_footer btn_footer-red"
      >
        Je retente ma chance
      </div>
      {{ /* Bouton de changement de genre non affiché si parcous enfant */ }}
      <div
        v-if="age == 'adulte' || age == 'ado'"
        @click="
          changeQuestion(node.retourGenre);
          RESET_OFFSET();
        "
        class="btn_footer btn_footer-white"
      >
        Je change d'univers
      </div>
    </div>

    {{ /* Affichage page de proposition "pour un proche"*/ }}
    <div
      v-if="current_question == 58 || current_question == 59"
      class="footer_recommandation"
    >
      {{ /* Au click on change l'offset avec selon la réponse donnée à la fréquence de lecture*/ }}
      <div
        @click="relance(offSetFreq, node.next)"
        class="btn_footer btn_footer-red"
      >
        Je retente ma chance
      </div>

      <div
        v-if="age == 'adulte' || age == 'ado'"
        @click="
          changeQuestion(node.retourGenre);
          RESET_OFFSET();
        "
        class="btn_footer btn_footer-white"
      >
        Je change d'univers
      </div>
    </div>
  </div>
</template>

<script>
import { mapMutations, mapState } from "vuex";
// import JSON, questions, réponses, ID ...
import json from "./../arbre.js";

export default {
  data() {
    return {
      jsonArbre: json,
      // id pour masquer btn précédant aux pages de reco
      resultsQuestions: [
        8,
        9,
        58,
        59,
        71,
        72,
        73,
        74,
        100,
        101,
        171,
        172,
        173,
        174
      ]
    };
  },
  computed: {
    ...mapState([
      "history",
      "current_question",
      "current_page",
      "age",
      "genre",
      "freqLecture",
      "typeLecture",
      "oneShot",
      "envieNC",
      "suprise",
      "range",
      "offSet",
      "offSetFreq",
      "componentKey",
      "rien",
      "scenario"
    ]),
    showBtnBack() {
      const { resultsQuestions, current_page, current_question } = this;
      return (
        !resultsQuestions.includes(current_question) &&
        current_page !== "accueil"
      );
    },
    node() {
      return this.jsonArbre.find(branch => branch.id === this.current_question);
    }
  },
  // les différentes methodes du store
  methods: {
    ...mapMutations([
      "SET_CURRENTPAGE",
      "SET_CURRENTQUESTION",
      "SET_BACKHISTORY",
      "SET_ADDHISTORY",
      "SET_RESETHISTORY",
      "SET_AGE",
      "SET_GENRE",
      "SET_FREQLECTURE",
      "SET_TYPELECTURE",
      "SET_ONESHOT",
      "SET_ENVIENC",
      "SET_SURPRISE",
      "SET_OFFSET",
      "SET_INITOFFSET",
      "RESET_OFFSET",
      "SET_RANGE",
      "SET_COMPONENTKEY",
      "SET_SCENARIO",
      "SET_RIEN"
    ]),
    backHistory: function() {
      // Supprime l'id de la question courante
      this.SET_BACKHISTORY();
      // récupération de l'id de la question précédante
      const prevID = this.history.slice(-1)[0];
      // changement de la question courante avec l'id précédente
      this.SET_CURRENTQUESTION(prevID);
      // si historique vide, on retourne sur la premiere question
      if (this.history.length == 0) {
        this.SET_CURRENTQUESTION(0);
        this.SET_CURRENTPAGE("accueil");
      }
      document.querySelector(".liste_choix").scrollTop = 1;
    },
    relance: function(offSetFreq, id) {
      //this.SET_RANGE(nb);
      this.SET_OFFSET(offSetFreq);
      this.SET_CURRENTQUESTION(id);
      this.SET_ADDHISTORY(id);
      this.SET_COMPONENTKEY();
    },
    changeQuestion: function(id) {
      this.SET_CURRENTQUESTION(id);
      // a chaque changement de question, on enregistre son id pour l'historique
      this.SET_ADDHISTORY(id);
      this.SET_COMPONENTKEY();
      this.SET_INITOFFSET(5);
    },
    changeOffset: function(offSetFreq) {
      this.SET_OFFSET(offSetFreq);
    },
    // au click sur précédant, on vide la valeur de la question courante
    clearState: function(event, value) {
      const mutation = "SET_" + event.toUpperCase();
      this[mutation](value);
    }
  }
};
</script>

<style lang="scss" scoped>
$red: #f52246;
.footer {
  position: absolute;
  left: 0;
  bottom: 0;
  z-index: 1;
  width: 100%;
  padding: 0;
  color: $red;
  font-size: 15px;
  font-weight: 600;

  text-align: left;

  @media screen and (max-width: 340px) and (max-height: 570px) {
    height: 60px;
    line-height: 60px;
  }
}

.wrapper_results .footer {
  position: static;
}

// footer visible pendant les questions
.footer_question {
  display: flex;
  justify-content: flex-end;
  align-items: center;
  width: 100%;
  height: 80px;
  padding: 0 20px;
  line-height: 80px;
  background-color: white;
}

// 1er écran de recommandation
.footer_recommandation {
  width: 100%;
  padding: 15px 20px;
  text-align: center;
  background-color: $red;

  .btn_footer {
    width: 100%;
    margin-top: 10px;
  }
}
.footer_texte {
  color: white;
}

.btn_footer {
  display: inline-block;
  height: 50px;
  line-height: 50px;
  padding: 0 20px;
  background-color: $red;
  border-radius: 4px;
  color: white;
  cursor: pointer;
}

.btn_footer-white {
  background-color: white;
  color: $red;
}

.btn_footer-red {
  border: 1px solid white;
}

// btn prédécant
.btn_footer-back {
  position: relative;
  display: inline-block;
  position: absolute;
  left: 20px;
  top: 50%;
  transform: translate(0, -50%);
  padding-left: 20px;
  font-size: 12px;
  cursor: pointer;
}

.btn_footer-back:before {
  content: "";
  position: absolute;
  left: 0px;
  top: 50%;
  transform: translate(-50%, -50%);
  width: 10px;
  height: 18px;
  background: url(../img/icon_back.svg) no-repeat center / contain;
}
</style>
